import './DashboardLoanCard.css'
import { useNavigate } from 'react-router-dom';
import { UpdateToken, toCamelCase, formatToIndianRupees } from '../../Global/Index';
import { toast } from 'react-toastify';
import { useTheme } from '@mui/material';


const DashboardLoanCard = (singleloandetail) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const OppertunityId = singleloandetail.loandetail.oppertunityId;
  const LoanType = singleloandetail.loandetail.Loantype;
  const LoanStatus = singleloandetail.loandetail.LoanStatus;
  const LoanAccountNumber = singleloandetail.loandetail.LoanAccountNumber;
  const FinOneLoanId = singleloandetail.loandetail.FinOneLoanId;
  const LoanAccountName = singleloandetail.loandetail.LoanAccountName
  const LoanAmount = singleloandetail.loandetail.LoanAmmount;



  const redirectme = async () => {


    try {
      const response = await UpdateToken(OppertunityId, LoanType, LoanAccountNumber, FinOneLoanId)
      if (response.response.status == '200') {
        navigate(`/success/Account-Summary`);
      } else if (response.response.status == '401') {
        window.location.href = '/'
      }
      else {
        toast.error(response.response.message)
      }
    } catch (error) {
      console.log(error)
    }


  };

  return (
    <div>
      <div className='dashboard_loan_card' style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>

        <div style={{width:'100%',marginBottom:'1vh',paddingLeft:'.8vh'}}><b>{LoanAccountName}</b></div>

        <div className="part1">
          <h6 className='loan_type'>{toCamelCase(LoanType)}</h6>
          <div className='status '>{LoanStatus} </div>
        </div>
        <div className="part2">
          <div className="part2left">
            <div className='account_fied'>
              <div className='account_type'>Loan Number</div>
              <div className='account_no details'>{LoanAccountNumber}</div>
            </div>
            <div className='amount_fied'>
              <div className='loan_amount'>Loan Amount</div>
              <div className='amount details'>  {LoanAmount == null ? 0 : formatToIndianRupees(LoanAmount)}</div>
            </div>
          </div>
          <div className='detail_btn'>
            <button type="submit" onClick={() => { redirectme() }} style={{ background: theme.palette.maincolor.buttoncolor, color: theme.palette.maincolor.light }}>View Details <i className="bi bi-arrow-right" /></button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardLoanCard;